import { render, staticRenderFns } from "./JobAlerts.vue?vue&type=template&id=0e5437fb&scoped=true&"
import script from "./JobAlerts.vue?vue&type=script&lang=js&"
export * from "./JobAlerts.vue?vue&type=script&lang=js&"
import style0 from "./JobAlerts.vue?vue&type=style&index=0&id=0e5437fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5437fb",
  null
  
)

export default component.exports